import React from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  MenuItem,
  TextField,
  Grid,
  CircularProgress,
  Box,
  Autocomplete,
  Stack,
  Button,
} from "@mui/material";
import { OBTENER_PERSONAS } from "../../graphql/personas";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useFormik } from "formik";
import Moment from "moment";
import { REPORTESRANGOFECHA } from "../../graphql/reporteador";
const ListaReportes = ({ setDatos }) => {
  const [reporteCobrosPorDia, { loading, error, data }] =
    useLazyQuery(REPORTESRANGOFECHA);
  const formik = useFormik({
    initialValues: {
      tipo: "0",
      fechaInicio: "",
      fechaFin: "",
      PersonaId: "",
    },
    onSubmit: async (inputData) => {
      try {
        if (inputData.fechaFin < inputData.fechaInicio) {
          throw Error("La fecha de Fin no puede ser menor a la de inicio");
        }
        const datos = await reporteCobrosPorDia({
          variables: {
            fechaInicio: inputData.fechaInicio,
            fechaFin: inputData.fechaFin,
            tipo: inputData.tipo,
            PersonaId: inputData.PersonaId
          },
        });
        console.log(datos.data.reportesRangoFechas)
        setDatos(datos.data.reportesRangoFechas);
      } catch (error) {
        console.log(error);
      }

      console.log(inputData);
      // try {
      //   if (inputData.fechaInicio > inputData.fechaFin) {
      //     throw Error("La fecha de Inicio no puede ser mayor a la de Fin");
      //   }
      //   const datos = await reportesDelegados({
      //     variables: {
      //       entry: {
      //         fechaInicio: inputData.fechaInicio,
      //         fechaFin: inputData.fechaFin,
      //         PersonaId: parseInt(inputData.PersonaId),
      //       },
      //     },
      //   });

      //   setDatos(datos.data.reportesDelegados);
      //   setOpenDialog(false);
      //   setTitle(
      //     `Reporte de la fecha ${Moment(inputData.fechaInicio).format(
      //       "DD-MMMM-YYYY"
      //     )} a la fecha ${Moment(inputData.fechaFin).format("DD-MMMM-YYYY")}`
      //   );
      // } catch (error) {
      //   console.log(error);
      // }
    },
  });
  const {
    data: personadata,
    loading: personaloading,
    error: personaerror,
  } = useQuery(OBTENER_PERSONAS);

  const filtro2 = [
    {
      value: "0",
      label: "Reporte General",
    },
    {
      value: "1",
      label: "Reporte Basura",
    },
    {
      value: "2",
      label: "Reporte Permisos",
    },
  ];

  if (personaloading)
    return (
      <>
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </>
    );

  const { obtenerPersonas } = personadata;
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              fullWidth
              name="tipo"
              select
              label="Filtros disponibles"
              helperText="Por favor seleccione una opción"
              variant="standard"
              value={formik.values.tipo}
              onChange={formik.handleChange}
            >
              {filtro2.map((opcion) => (
                <MenuItem key={opcion.value} value={opcion.value}>
                  {opcion.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Autocomplete
              fullWidth
              id="PersonaId"
              name="PersonaId"
              options={obtenerPersonas}
              getOptionLabel={(option) =>
                option.nombre + " " + option.apellidos
              }
              onChange={(e, value) => {
                formik.setFieldValue("PersonaId", value.id);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="PersonaId"
                  label="Delegado"
                  fullWidth
                  variant="standard"
                />
              )}
            />
            {formik.errors.PersonaId}
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                onChange={(date) => formik.setFieldValue("fechaInicio", date)}
                value={formik.values.fechaInicio}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="fechaInicio"
                    fullWidth
                    variant="standard"
                    label="Fecha de Inicio"
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={12} lg={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                onChange={(date) => formik.setFieldValue("fechaFin", date)}
                value={formik.values.fechaFin}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="fechaFin"
                    fullWidth
                    variant="standard"
                    label="Fecha de Fin"
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
          <Button type="submit">Filtrar</Button>

          {/* <Button onClick={() => handleOpenDialog()}>Cerrar</Button> */}
        </Stack>
      </form>
      {/* <List>
        {obtenerListaReportes.map((contenido) => (
          <ListItem disablePadding>
            
            <ListItemButton href={contenido.ruta}>
              <ListItemText
                primary={contenido.reporte}
                secondary={contenido.descripcion}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
    </>
  );
};

export default ListaReportes;
